import { OrderPaymentSchedule } from '@afterpaytouch/portal-api'
import { useOrderGetPaymentScheduleSet, useIsFinalOrderDue } from '../../state/orders/hooks'
import { getFirstDueSchedule } from '../../state/orders/utils'

export const useGetInitialSchedules = (orderId: string): OrderPaymentSchedule[] => {
  const paymentScheduleSet = useOrderGetPaymentScheduleSet(orderId)
  const isFinalOrderDue = useIsFinalOrderDue(orderId)
  const firstDueSchedule = getFirstDueSchedule(paymentScheduleSet)

  if (typeof paymentScheduleSet === 'undefined') {
    // @ts-ignore: OPERATION BLEED STOPPER
    return null
  }
  if (isFinalOrderDue) {
    return [paymentScheduleSet[paymentScheduleSet.length - 2], firstDueSchedule]
  }
  return [firstDueSchedule ?? paymentScheduleSet[0], paymentScheduleSet[paymentScheduleSet.length - 1]]
}
